import { OverridesStyleRules } from '@mui/material/styles/overrides';

import type { CustomTheme } from '@/theme/theme.types';

export const DATA_GRID: OverridesStyleRules = {
    MuiDataGrid: {
        defaultProps: {
            pageItems: 10,
            headerHeight: 36,
            rowHeight: 32,
            rowsPerPageOptions: [5, 10, 25, 40],
            pagination: true,
        },
        styleOverrides: {
            root: ({ theme }: { theme: CustomTheme }) => ({
                backgroundColor: `${theme.palette.common.white}`,
                border: 'none',
            }),
            cell: ({ theme }: { theme: CustomTheme }) => ({
                ...theme.typography.body,
                '&:focus, &:focus-within': {
                    outline: 'none',
                },
            }),
            columnHeaders: {
                borderBottom: 'none',
            },
            footerContainer: {
                position: 'relative',
                height: '1rem',
            },
            columnSeparator: {
                display: 'none',
            },
            columnHeader: ({ theme }: { theme: CustomTheme }) => ({
                backgroundColor: `${theme.palette.primary.light}`,

                '&:focus-within': {
                    outline: 'none',
                },
                '& .MuiBadge-badge': {
                    fontSize: '1rem',
                },
            }),
            columnHeaderTitle: ({ theme }: { theme: CustomTheme }) => ({
                ...theme.typography.h5,
                color: `${theme.palette.primary.dark}`,
            }),
            overlay: {
                minHeight: '20rem',
            },
            filterForm: {
                '& .MuiDataGrid-filterFormColumnInput': {
                    display: 'flex',
                    alignSelf: 'end',
                    paddingBottom: '0.8rem',
                    paddingRight: '1rem',
                },
                '& .MuiDataGrid-filterFormLinkOperatorInput': {
                    display: 'none',
                    minwidth: 0,
                    width: 0,
                },
                '& .MuiDataGrid-filterFormOperatorInput': {
                    paddingRight: '1rem',
                },
                '& .MuiDataGrid-filterFormValueInput label': {
                    display: 'none',
                },
            },
            columnsPanelRow: {
                span: {
                    fontSize: '1.2rem',
                    fontWeight: 500,
                },
                '& .MuiSwitch-root': {
                    background: 'white',
                    borderRadius: '2rem',
                    marginLeft: '1.5rem',
                    width: '3.6rem',
                    height: '2rem',
                    '& .MuiSwitch-thumb': {
                        width: '1.2rem',
                        height: '1.2rem',
                    },
                },
            },
            menu: ({ theme }: { theme: CustomTheme }) => ({
                '& .MuiPaper-root': {
                    borderRadius: '0.4rem',
                    backgroundColor: `${theme.palette.headings.dark}`,
                    '& li': {
                        ...theme.typography.body,
                        color: `${theme.palette.common.white}`,
                    },
                    '& .css-9mgopn-MuiDivider-root': {
                        borderColor: `${theme.palette.common.white}`,
                    },
                },
            }),
        },
    },

    MuiTablePagination: {
        styleOverrides: {
            root: {
                display: 'flex',
                width: '100%',
                borderBottom: '0',
            },
            toolbar: {
                minHeight: '4rem',
                width: '100%',
                '&.MuiToolbar-root': {
                    paddingLeft: 0,
                    paddingRight: 0,
                },
            },
            spacer: {
                flex: 'none',
            },
            selectLabel: ({ theme }: { theme: CustomTheme }) => ({
                ...theme.typography.body,
            }),
            displayedRows: ({ theme }: { theme: CustomTheme }) => ({
                ...theme.typography.body,
                flex: '1 1 100%',
                textAlign: 'right',
            }),
            select: ({ theme }: { theme: CustomTheme }) => ({
                ...theme.typography.body,
            }),
        },
    },
};
